// extracted by mini-css-extract-plugin
export default {"title":"styles_title__7PJrl","containerOption":"styles_containerOption__NlCGI"};